let HelpLinks = {
  ReportAuditWithDrawBudget: 'https://mimosahelp.misa.vn/kb/kiem-tra-so-rut-va-chi-theo-mlns/',
  ReportAuditSalary:
    'https://mimosahelp.misa.vn/knowledge-base/kiem-tra-so-du-tai-khoan-luong-va-cac-khoan-trich-theo-luong/',
  ReportAuditAnomalyBusiness: {
    P1: 'https://mimosahelp.misa.vn/kb/9-1-hach-toan-tai-khoan-thuong-xuyen-nhung-chon-nguon-khong-thuong-xuyen/',
    P2: 'https://mimosahelp.misa.vn/kb/hach-toan-no-tk-3371-3372-511x-nhung-nghiep-vu-khong-chon-la-nop-khoi-phuc-hay-nop-tra/',
    P3: 'https://mimosahelp.misa.vn/kb/9-3-hach-toan-co-tk-611x-nhung-nghiep-vu-khong-chon-la-giam-chi-hay-xuat-toan/',
    P4: 'https://mimosahelp.misa.vn/kb/9-4-cac-but-toan-lenh-chi-tien-nhung-cap-phat-khong-la-lenh-chi-nghiep-vu-chua-dung/',
  },
  ReportAuditMovementBalance: {
    P1: 'https://mimosahelp.misa.vn/kb/10-1-kiem-tra-tong-tai-san-va-tong-nguon-von-dau-nam/',
    P2: 'https://mimosahelp.misa.vn/kb/10-2-kiem-tra-tinh-chat-tai-khoan-so-voi-che-do-hien-hanh/',
    P3: 'https://mimosahelp.misa.vn/kb/10-3-kiem-tra-so-du-tai-khoan-doanh-thu-chi-phi/',
  },
  ReportFinancial: 'https://mimosahelp.misa.vn/kb/kiem-tra-bao-cao-tai-chinh/',
  ReportSettlement: 'https://mimosahelp.misa.vn/kb/12-kiem-tra-bao-cao-quyet-toan/',
};

let AuditType = {
  WithDrawBudget: 7,
  Salary: 8,
  AnomalyBusiness: 9,
  MovementBalance: 10,
  FinanceReport: 11,
  SettlementReport: 12,
};

let AuditTypeName = {
  WithDrawBudget: 'Sổ rút và chi theo mục lục ngân sách',
  Salary: 'Tài khoản lương và các khoản trích theo lương',
  AnomalyBusiness: 'Nghiệp vụ bất thường',
  MovementBalance: 'Bảng cân đối phát sinh',
  FinanceReport: 'Báo cáo tài chính',
  SettlementReport: 'Báo cáo quyết toán',
};

export default {
  HelpLinks,
  AuditType,
  AuditTypeName,
};
